import React from 'react';
import { message } from 'antd';

import SearchEventListModalView from './SearchEventListModalView';
import { useSearchEventListModalViewModel } from './useSearchEventListModalViewModel';
import { _LIST_PAGINATION_MODEL } from '../../../../../../../../store/modules/app/models';

export const INITIAL_OPTION = {
  filterOption: { id: null, status: null, mainTitle: null },
  pagination: _LIST_PAGINATION_MODEL,
};

interface ISearchEventListModalContainerProps {
  closeModal: () => void;
  onSubmit: (eventId: number) => void;
}
const SearchEventListModalContainer = (props: ISearchEventListModalContainerProps) => {
  const { closeModal, onSubmit } = props;
  const { eventList, totalCount, selectedIdList, option, dispatchOption, onCheck } = useSearchEventListModalViewModel();

  const handleSubmit = () => {
    if (!selectedIdList.length) {
      message.error('기획전을 최소 1개는 선택하셔야 합니다.');
      return;
    }
    onSubmit(selectedIdList[0]);
    closeModal();
  };

  return (
    <SearchEventListModalView
      closeModal={closeModal}
      onSubmit={handleSubmit}
      eventList={eventList}
      totalCount={totalCount}
      option={option}
      dispatchOption={dispatchOption}
      selectedIdList={selectedIdList}
      onCheck={onCheck}
    />
  );
};

export default SearchEventListModalContainer;
